import React from 'react';

const TableSearch = ({ onSearch, value = ""}) => {

    return (
        <div>
            <input
                type="text"
                value={value}
                onChange={onSearch}
                placeholder="Rechercher..."
                className={""}
                style={{
                    marginRight: "8px",
                    padding: "5px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                    height: "100%"
                }}            />
        </div>
    );
};

export default TableSearch;
